// extracted by mini-css-extract-plugin
export default {"cabin":"styles_cabin__cYsQ0","cabinBackground":"styles_cabinBackground__U9uN+","monitor":"styles_monitor__nvFqw"};